/** @prettier */

import {FC} from 'react';
import '../../../css/common/common.css';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import {iconBlack} from '../../../define';

type Props = {
  x: number;
  y: number;
  unitName: string;
  iconSrc?: string;
};

const DragPreviewPresenter: FC<Props> = ({
  x,
  y,
  unitName,
  iconSrc = iconBlack.AC_ON.src,
}) => {
  return (
    <Box
      style={{
        zIndex: 10,
        position: 'absolute',
        top: y,
        left: x,
        //こいつが無いとドロップ処理が上手くいかない
        pointerEvents: 'none',
      }}>
      <Stack>
        <Box
          className="groupSetting__contents__layoutContents__layoutBox--setting__icon--preview"
          style={{
            backgroundImage: `url(${iconSrc})`,
          }}></Box>
        <Box className="groupSetting__contents__layoutContents__layoutBox--setting__text--preview">
          {unitName}
        </Box>
      </Stack>
    </Box>
  );
};
export default DragPreviewPresenter;
